import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Autocomplete,
  Button,
  Card,
  CardHeader,
  Divider,
  Checkbox,
  CardContent,
  Grid,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormGroup,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  IconButton

} from '@mui/material';

import Loader from 'components/Loader';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import DeleteIcon from '@mui/icons-material/Delete';

import PhoneInput from "react-phone-input-2";
import { CountryDropdown } from 'react-country-region-selector';
import "react-phone-input-2/lib/bootstrap.css";
import {
  editCompany as editCompanyService,
  fetchSingleCompany as fetchSingleCompanyService,
  fetchCompanyTypes as fetchCompanyTypesService,
  fetchCurrencies as fetchCurrenciesService,
  fetchIndustries as fetchIndustriesService,
  fetchFrequencies as fetchFrequenciesService,
  fetchApplications as fetchApplicationsService,
  fetchSubscriptionPlans as fetchSubscriptionPlansService
} from 'services/modules/idp/company';
import { useNotification } from 'config/Notification';
import { fetchCompanyVAPTDimensions as fetchCompanyVAPTDimensionsService, fetchDimensionsVAPT } from 'services/modules/vapt/data';
import { fetchCloudTypes as fetchCloudTypesService } from 'services/modules/vapt/alert';
import { getSOCEnvironment, getSOCGroupValidation } from 'services/modules/soc/agent';
import { setCompanyData } from 'stores/modules/idp/authreducer';



const Editcompany = () => {

  // Notification
  const { openNotification } = useNotification();

  // Redux dispatch
  const dispatch = useDispatch();

  // useParams hook
  const { companyId } = useParams();

  // State variables
  const [phone, setPhone] = useState("");
  const [nacecode, setNaceCode] = useState("NACE")
  const [countryName, setCountryName] = useState('');
  const [employeError, setEmployeError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [selectedDimensions, setSelectedDimensions] = useState([]);
  const [loading,setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    ppt_report: '',
    name: '',
    domain: '',
    contactname: '',
    email: '',
    companytype: '',
    country: '',
    location: {
      name: '',
      coords: [0, 0],
    },
    locate: '',
    employesize: '',
    currency: '',
    industry: '',
    subscriptionPlan: '',
    reportFrequency: '',
    cloudtypes: [],
    applications: [],
    soc_group: '',
    soc_env:'',
    applicationWeightages: [],
    webapplications: [],
    network_locations: [],
    mobiletypes: [],
    category: [],
    mobile_code: '',
    mobile_digits: '',
    heatmap: '',
    supplier_type: '',
    supplier_types: ["Insignificant", "Routine", "Preferred", "Strategic"],
    partner: '',
    mobile: {
      code: '',
      digits: ''
    }
  });

  // Redux selectors
  const industriesContainer = useSelector((state) => state.company.industries);
  const frequenciesContainer = useSelector((state) => state.company.frequencies);
  const currenciesContainer = useSelector(state => state.company.currencies);
  const companyTypesContainer = useSelector(state => state.company.companytypes);
  const companyDataContainer = useSelector((state) => state.company.singleCompany);
  const authenticatedUserContainer = useSelector(state => state.auth.user);
  const subscriptionsContainer = useSelector(state => state.company.subscriptionPlans);
  const servicesContainer = useSelector(state => state.company.applications);
  const companyNamesContainer = useSelector((state) => state.company.companies);
  const hasCreateAnyCompanies = authenticatedUserContainer.roles.some(role => role.permissions.includes('CREATE_ANY_COMPANIES'));
  const vaptDimensionsContainer = useSelector((state) => state.vaptData.vaptDimensions);
  const cloudTypesContainer = useSelector((state) => state.vaptAlert.cloudtypes);

  const [dynamicFields, setDynamicFields] = useState(['']);
  const [dynamicFieldsNetwork, setDynamicFieldsNetwork] = useState(['']);
  const [socEnvironmentOptions,setSocEnvironmentOptions] = useState([''])

  // useEffect dispatches the actions and updates the store 
  useEffect(() => {
    dispatch(fetchSingleCompanyService({ companyId }));
    dispatch(fetchCompanyTypesService());
    dispatch(fetchCurrenciesService());
    dispatch(fetchIndustriesService());
    dispatch(fetchFrequenciesService());
    dispatch(fetchCloudTypesService());
    dispatch(fetchApplicationsService());
    dispatch(fetchDimensionsVAPT({}))
    if (hasCreateAnyCompanies) {
      dispatch(fetchSubscriptionPlansService());
      fetchSaveDimensions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Method handles to fetch the saved VAPT dimensions based on company id
  const fetchSaveDimensions = async () => {
    let params = { company: companyId }
    let response = await fetchCompanyVAPTDimensionsService({ params });
    setSelectedDimensions(response);
  }

  useEffect(()=>{
     const fetchData= async()=>{
       let response = await getSOCEnvironment();
       setSocEnvironmentOptions(response);
     }
     fetchData();
  },[])

  useEffect(() => {
    if (companyDataContainer) {
      setFormData({
        ppt_report: companyDataContainer?.ppt_report,
        name: companyDataContainer?.name,
        domain: companyDataContainer?.domain,
        contactname: companyDataContainer?.contactname,
        email: companyDataContainer?.email || '',
        companytype: companyDataContainer.companytype || '',
        country: companyDataContainer.country || '',
        partner: companyDataContainer.partner || '',
        location: {
          name: '',
          coords: [0, 0]
        },
        locate: companyDataContainer.location ? companyDataContainer.location.name : '',
        employesize: companyDataContainer.employesize || '',
        category: companyDataContainer.applications?.filter((app) => app.slug === 'vapt').length > 0
          ? companyDataContainer?.category : [],
        currency: companyDataContainer.currency || '',
        industry: companyDataContainer.industry ? companyDataContainer.industry.id : '',
        subscriptionPlan: companyDataContainer.subscriptionPlan ? companyDataContainer.subscriptionPlan.id : '',
        reportFrequency: companyDataContainer.reportFrequency ? companyDataContainer.reportFrequency.id : '',
        applications: companyDataContainer.applications
          ? (Array.isArray(companyDataContainer.applications)
            ? companyDataContainer.applications.map((application) => application.id)
            : [companyDataContainer.applications.id])
          : [],
        applicationWeightages: companyDataContainer?.applicationWeightages
          ? companyDataContainer.applicationWeightages.map(({ application, weightage }) => ({
            application: application.id,
            weightage
          }))
          : [],
        soc_group: companyDataContainer?.soc_group || '',
        soc_env: companyDataContainer?.soc_env || '',
        cloudtypes: companyDataContainer?.applications?.filter((app) => app.slug === 'vapt').length > 0
          ? companyDataContainer?.cloudtypes : [],
        webapplications: companyDataContainer?.webapplications || [],
        network_locations: companyDataContainer?.network_locations || [],
        mobiletypes: companyDataContainer?.mobiletypes || [],
        mobile_code: companyDataContainer?.mobile?.code,
        mobile_digits: companyDataContainer?.mobile?.digits,
        heatmap: companyDataContainer?.heatmap || '',
        supplier_type: companyDataContainer?.supplier_type || '',
        supplier_types: ["Insignificant", "Routine", "Preferred", "Strategic"],
        mobile: {
          code: '',
          digits: ''
        }
      });
      const webData = companyDataContainer?.webapplications || [];
      setDynamicFields(webData)
      const networkData = companyDataContainer?.network_locations || [];
      setDynamicFieldsNetwork(networkData)
    }
  }, [companyDataContainer, selectedDimensions]);

  // This method displays the form error if the form validation is not satisfied
  const handleErrors = (fieldName) => {
    setFormErrors((prevformErrors) => ({
      ...prevformErrors,
      [fieldName]: true,
    }));
  };

  // This method handles change in autocomplete fields
  const handleAutocompleteChange = (event, newValue) => {
    const selectedId = newValue ? newValue.id : '';
    handleInputChange({ target: { name: 'industry', value: selectedId } });
  };

  // Handles changes in form input fields
  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    if (name === "mobile_digits" && !/^\d+$/.test(value)) {
      setPhoneError("Only Digits");
    } else {
      setPhoneError("");
    }
    if (name === "email" && !/^\S+@\S+\.\S+$/.test(value)) {
      setEmailError("Invalid email");
    } else {
      setEmailError("");
    }
    if (name === "employesize" && !/^\d+$/.test(value)) {
      setEmployeError("Employee size must be a valid number");
    } else if (name === "employesize" && parseInt(value) === 0) {
      setEmployeError("Employee size cannot be 0");
    } else {
      setEmployeError("");
    }

    if (type === 'checkbox' && name === 'applications') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        applications: checked
          ? [...prevFormData.applications, value]
          : prevFormData.applications.filter((appId) => appId !== value),
      }));
    }
    else if (type === 'checkbox' && name === 'category') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        category: checked
          ? [...prevFormData.category, value]
          : prevFormData.category.filter((appId) => appId !== value),
      }));
    }
    else if (type === 'checkbox' && name === 'cloudtypes') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        cloudtypes: checked
          ? [...prevFormData.cloudtypes, value]
          : prevFormData.cloudtypes.filter((appId) => appId !== value),
      }));
    }
    else {
      setFormData({
        ...formData,
        [name]: type === 'checkbox' ? checked : value,
      });
    }
  };

  // Handles the form submission 
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      if (formData.applications.includes(applicationSlugToIdMap['vapt']) && formData.category.length === 0) {
        openNotification('Atleast one category must be selected', 'error')
        return;
      }
      if (formData.applications.includes(applicationSlugToIdMap['vapt']) && formData.category.includes(categorySlugToIdMap['web-application']) && formData.webapplications.length === 0) {
        openNotification('Please fill the Web Applications field', 'error');
        return;
      }
      if (formData.applications.includes(applicationSlugToIdMap['vapt']) && formData.category.includes(categorySlugToIdMap['network']) && formData.network_locations.length === 0) {
        openNotification('Please fill the Network Locations field', 'error');
        return;
      }
      if (formData.applications.includes(applicationSlugToIdMap['vapt']) && formData.category.includes(categorySlugToIdMap['mobile']) && formData.mobiletypes.length === 0) {
        openNotification('Atleast one mobile type must be selected', 'error');
        return;
      }
      if (formData.applications.includes(applicationSlugToIdMap['vapt']) && formData.category.includes(categorySlugToIdMap['cloud']) && formData.cloudtypes?.length === 0) {
        openNotification('Atleast one cloud type must be selected', 'error');
        return;
      }
      if(formData.applications.includes(applicationSlugToIdMap['soc'])&& formData.soc_group !== '' && formData.soc_env !==''){
        let response = await getSOCGroupValidation({group:formData.soc_group,soc_env:formData.soc_env});
        if(!response?.data)
        {
          openNotification(response.message,'error');
          return;
        }     
      }
      else{
        delete formData.soc_group;
        delete formData.soc_env;
      }
      const updatedFormData = { ...formData };
      delete updatedFormData.partner;
      updatedFormData.mobile = {
        code: phone ? phone : formData.mobile_code,
        digits: formData.mobile_digits,
      };
      delete updatedFormData.mobile_code;
      delete updatedFormData.mobile_digits;
      delete updatedFormData.domain;
      updatedFormData.country = countryName ? countryName : formData.country;
      updatedFormData.location = {
        name: updatedFormData.locate,
        coords: [0, 0],
      };
      updatedFormData.network_locations = formData?.network_locations?.map((app)=>app.trim());
      updatedFormData.webapplications = formData?.webapplications?.map((app)=>app.trim());
      let obj={};
      obj.companyid=companyId;
      obj.companyname = updatedFormData.name;
      obj.domain= updatedFormData.domain;
      obj.soc_group=updatedFormData.soc_group;
      obj.soc_env=updatedFormData.soc_env;
      delete updatedFormData.locate;
      if (!hasCreateAnyCompanies)
        delete updatedFormData.applications;
      delete updatedFormData.supplier_types;
      if (updatedFormData.supplier_type === '')
        delete updatedFormData.supplier_type
      if (updatedFormData.heatmap === '')
        delete updatedFormData.heatmap;

      setLoading(true)
      const response = await editCompanyService(companyId, updatedFormData)
      if (response?.status === 200 || response?.status === 201) {
        openNotification('Company edited successfully', 'success');
        dispatch(setCompanyData(obj))
        window.history.back();
      } else {
        openNotification(response, 'error')
      }

    } catch (error) {
      openNotification('Error while editing company', 'error')
    }finally{
      setLoading(false)
    }
  };

  // Handles adding a new dynamic field for web applications
  const handleAddField = () => {
    setDynamicFields([...dynamicFields, '']);
  };

  // Handles adding a new dynamic field for network
  const handleAddFieldNetwork = () => {
    setDynamicFieldsNetwork([...dynamicFieldsNetwork, '']);
  };

  // Handles changing a dynamic field for webapplications
  const handleDynamicFieldChange = (index, value) => {
    const updatedFields = [...dynamicFields];
    updatedFields[index] = value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      webapplications: updatedFields
    }));
    setDynamicFields(updatedFields);
  };

  // Handles changing a dynamic field for network
  const handleDynamicFieldChangeNetwork = (index, value) => {
    const updatedFields = [...dynamicFieldsNetwork];
    updatedFields[index] = value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      network_locations: updatedFields
    }));
    setDynamicFieldsNetwork(updatedFields);
  };

  // Handles removing a dynamic field for web applications
  const handleRemoveField = (index) => {
    const updatedFields = [...dynamicFields];
    updatedFields.splice(index, 1);
    setDynamicFields(updatedFields);
    setFormData((prevFormData) => ({
      ...prevFormData,
      webapplications: updatedFields
    }))
  };

  // Handles removing a dynamic field for Network
  const handleRemoveFieldNetwork = (index) => {
    const updatedFields = [...dynamicFieldsNetwork];
    updatedFields.splice(index, 1);
    setDynamicFieldsNetwork(updatedFields);
    setFormData((prevFormData) => ({
      ...prevFormData,
      network_locations: updatedFields
    }))
  };

  // Handle the changes for mobiletypes
  const handleMobileTypesChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      mobiletypes: checked
        ? [...prevFormData.mobiletypes, value]
        : prevFormData.mobiletypes.filter((type) => type !== value),
    }));
  }

  const createSlugToIdMap = (items, idKey = '_id') => {
    return items?.reduce((map, item) => {
      map[item.slug] = item[idKey];
      return map;
    }, {});
  };

  const categorySlugToIdMap = createSlugToIdMap(vaptDimensionsContainer);
  const applicationSlugToIdMap = createSlugToIdMap(servicesContainer, 'id');

  return (
    <div className="card-container">
      <Card className="card">
        <CardHeader
          title={
            <React.Fragment>
              <div className='card-head'>
                <div className="deflex-head">
                  <img src="/assets/partners.svg" alt="icon" className="card-icon" />
                  <label className='label'> Partners<ArrowRightIcon className='header-size' /> Edit partner</label>
                </div>
                <div>
                  <Button variant="contained" className="back font" onClick={() => window.history.back()}>Back</Button>
                </div>
              </div>
            </React.Fragment>
          }
        />
        <Divider className="divider" />
        <CardContent className="center-card">
          <Card className="user-card row company-screen-bg">
            {loading && (
               <div className="loader-overlay-dashboard">
                        <Loader />
                      </div>
            )}
            <div className="row col-lg-12">
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md ">
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    fullWidth
                    name="name"
                    label="Company Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    onBlur={() => handleErrors('name')}
                    error={formData.name === '' && formErrors.name}
                    helperText={formData.name === '' && formErrors.name ? 'Field is required' : ''}
                  />
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md">
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    fullWidth
                    name="domain"
                    label="Domain URL"
                    value={formData.domain}
                    onChange={handleInputChange}
                    disabled
                  />
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    fullWidth
                    name="contactname"
                    label="Contact Name"
                    value={formData.contactname}
                    onChange={handleInputChange}
                    onBlur={() => handleErrors('contactname')}
                    error={formData.contactname === '' && formErrors.contactname}
                    helperText={formData.contactname === '' && formErrors.contactname ? 'Field is required' : ''}
                  />
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md flex">
                <Grid item>
                  <PhoneInput
                    fullWidth
                    className="tellphone pos"
                    country={"india"}
                    enableSearch={true}
                    value={phone ? phone : formData.mobile_code}
                    onChange={(country) => setPhone(country)}
                  />
                </Grid>
                <TextField
                  variant="outlined"
                  fullWidth name="mobile_digits"
                  label="Phone"
                  value={formData.mobile_digits}
                  onChange={handleInputChange}
                  onBlur={() => handleErrors('mobile_digits')}
                  error={(formData.mobile_digits === '' && formErrors.mobile_digits) || !!phoneError}
                  helperText={(formData.mobile_digits === '' && formErrors.mobile_digits) ? 'Field is required' : phoneError || ''}
                />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    label="Email"
                    fullWidth
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    onBlur={() => handleErrors('email')}
                    error={(formData.email === '' && formErrors.email) || !!emailError}
                    helperText={(formData.email === '' && formErrors.email) ? 'Field is required' : emailError || ''}
                  />
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth>
                  <InputLabel htmlFor="companytype">Company type</InputLabel>
                  <Select
                    name="companytype"
                    value={formData.companytype}
                    onChange={handleInputChange}
                    label="Company Type"
                  >
                    <MenuItem value="">
                    </MenuItem>
                    {companyTypesContainer.data && companyTypesContainer.data.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.companytype}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md">
                <FormControl fullWidth>
                  <CountryDropdown
                    value={countryName === '' ? formData?.country : countryName}
                    onChange={(value) => setCountryName(value)}
                    className="country-dropdown company-screen-bg"
                  />
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    label="Location"
                    fullWidth name="locate"
                    value={formData.locate}
                    onChange={handleInputChange}
                    onBlur={() => handleErrors('locate')}
                    error={formData.locate === '' && formErrors.locate}
                    helperText={formData.locate === '' && formErrors.locate ? 'Field is required' : ''}
                  />
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth>
                  <InputLabel htmlFor="Curreny">Currency</InputLabel>
                  <Select
                    name="currency"
                    value={formData.currency}
                    onChange={handleInputChange}
                    label="Currency"
                  >
                    <MenuItem value="">
                    </MenuItem>
                    {currenciesContainer.data && currenciesContainer.data.map((currency) => (
                      <MenuItem key={currency.id} value={currency.id}>
                        {`${currency.Code}-${currency.Currency}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    label="No.of Employees"
                    fullWidth
                    name="employesize"
                    value={formData.employesize} onChange={handleInputChange}
                    onBlur={() => handleErrors('employesize')}
                    error={(formData.employesize === '' && formErrors.employesize) || !!employeError}
                    helperText={(formData.employesize === '' && formErrors.employesize) ? 'Field is required' : employeError || ''}
                  />
                </FormControl>
              </div>
              <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth>
                  <Autocomplete
                    options={industriesContainer?.data}
                    getOptionLabel={(option) => option?.label || ''}
                    value={industriesContainer?.data?.find((option) => option.id === formData.industry) || null}
                    onChange={handleAutocompleteChange}
                    renderInput={(params) => (
                      <TextField {...params} label="Industry" variant="outlined"
                        onBlur={() => handleErrors('industry')}
                        error={formData.industry === '' && formErrors.industry}
                        helperText={formData.industry === '' && formErrors.industry ? 'Field is required' : ''}
                      />
                    )}
                  />
                </FormControl>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth>
                  <InputLabel htmlFor="nace"> Standard</InputLabel>
                  <Select
                    name="nace"
                    value={nacecode}
                    onChange={() => setNaceCode('NACE')}
                    label="Standard"
                  >
                    <MenuItem value="NACE">
                      NACE
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
              {hasCreateAnyCompanies && companyNamesContainer.results && (
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-1">
                  <FormControl fullWidth>
                    <Autocomplete
                      disabled
                      options={companyNamesContainer.results || []}
                      getOptionLabel={(option) => option.name || ''}
                      value={companyNamesContainer.results.find((option) => option.id === formData.partner) || null}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Partner Company"
                          variant="outlined"
                          inputProps={{ ...params.inputProps, disabled: true }}
                        />

                      )}
                    />
                  </FormControl>
                </div>
              )}
              {frequenciesContainer && (
                <div className="report-frequency">
                  <FormControl component="fieldset">
                    <FormLabel component="legend" className="text-primary">Report frequency</FormLabel>
                    <RadioGroup
                      row
                      name="reportFrequency"
                      value={formData.reportFrequency}
                      onChange={handleInputChange}
                    >
                      {frequenciesContainer.map((frequency) => (
                        <FormControlLabel
                          key={frequency.id}
                          value={frequency.id}
                          control={<Radio />}
                          label={frequency.label}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </div>
              )}
              {hasCreateAnyCompanies && (
                <div className="report-frequency">
                  <FormControl component="fieldset">
                    <FormLabel component="legend" className="text-primary">Subscription plan</FormLabel>
                    <RadioGroup
                      row
                      name="subscriptionPlan"
                      value={formData.subscriptionPlan}
                      onChange={handleInputChange}
                    >
                      {subscriptionsContainer.map((subscription) => (
                        <FormControlLabel
                          key={subscription.id}
                          value={subscription.id}
                          control={<Radio />}
                          label={subscription.label}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </div>
              )}
              {hasCreateAnyCompanies && (
                <div className="report-frequency">
                  <FormControl component="fieldset">
                    <FormLabel component="legend" className="text-primary">Services</FormLabel>
                    <FormGroup row>
                      {servicesContainer && servicesContainer.map((application) => (
                        <FormControlLabel
                          key={application.id}
                          control={
                            <Checkbox
                              checked={formData.applications.includes(application.id)}
                              onChange={handleInputChange}
                              name="applications"
                              value={application.id}
                            />
                          }
                          label={application.label}
                        />
                      ))}
                    </FormGroup>
                  </FormControl>
                </div>
              )}
              {hasCreateAnyCompanies &&
                servicesContainer.some(application => (
                  (application.label === 'ECS') &&
                  formData.applications.includes(application.id)
                ))
                && (
                  <div className="report-frequency">
                    <FormControl component="fieldset">
                      <FormLabel component="legend" className="text-primary">PPT report generation</FormLabel>
                      <RadioGroup
                        row
                        name="ppt_report"
                        value={formData.ppt_report}
                        onChange={handleInputChange}
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </div>
                )}
              {hasCreateAnyCompanies
                && servicesContainer.some(application => ((application.label === 'ECS' || application.label === 'RHYMSCAN')
                  && (subscriptionsContainer?.filter((sub) => sub.id === formData?.subscriptionPlan)?.some((sub) => sub.slug !== "basic"))

                  && formData.applications.includes(application.id)))
                && (
                  <div className="report-frequency">
                    <FormControl component="fieldset">
                      <FormLabel component="legend" className="text-primary">Heatmap</FormLabel>
                      <RadioGroup
                        row
                        name="heatmap"
                        value={formData.heatmap}
                        onChange={handleInputChange}
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </div>
                )}
              {hasCreateAnyCompanies && formData.supplier_type !== '' && (
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md report-frequency">
                  <FormControl fullWidth>
                    <InputLabel htmlFor="supplier_type">Supplier type</InputLabel>
                    <Select
                      name="supplier_type"
                      value={formData.supplier_type}
                      onChange={handleInputChange}
                      label="Supplier Type"
                    >
                      {formData.supplier_types.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              )}
              {hasCreateAnyCompanies && servicesContainer.some(application => (
                (application.label === 'SOC') &&
                formData.applications.includes(application.id)
              )) &&
                (
                  <div className='row  mt-3'>
                    <div className="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-4 p-0 pt-2">
                      <FormLabel component="legend" className='text-primary'>
                        SOC Group
                      </FormLabel>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 p-0">
                      <FormControl fullWidth>
                        <TextField
                          variant="outlined"
                          label="SOC Group"
                          size='small'
                          fullWidth
                          name="soc_group"
                          value={formData.soc_group}
                          onChange={handleInputChange}

                        />
                      </FormControl>
                    </div>
                  </div>
                )
              }
               {hasCreateAnyCompanies && servicesContainer.some(application => (
                (application.label === 'SOC') &&
                formData.applications.includes(application.id)
              )) &&
                (
                  <div className='row  mt-3'>
                    <div className="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-4 p-0 pt-2">
                      <FormLabel component="legend" className='text-primary'>
                        SOC Environment
                      </FormLabel>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 p-0">
                     <FormControl fullWidth>
                                             <InputLabel htmlFor="soc_env">SOC Environment</InputLabel>
                                             <Select
                                               name="soc_env"
                                               value={formData.soc_env}
                                               onChange={handleInputChange}
                                               label="SOC Environment"
                                               size='small'
                                             >
                                               {socEnvironmentOptions.map((type) => (
                                                 <MenuItem key={type.id} value={type.name}>
                                                   {type.name}
                                                 </MenuItem>
                                               ))}
                                             </Select>
                                           </FormControl>
                    </div>
                  </div>
                )
              }
              {servicesContainer.some(application => (
                (application.label === 'VAPT') &&
                formData.applications.includes(application.id)
              )) && (
                  <>
                    <div className="card">
                      <div className="card-body">
                        <h5 class="card-title">VAPT Application & Service Setup</h5>

                        <div className="mt-3">
                          <FormControl component="fieldset">
                            <FormGroup row>
                              <span className="text-primary pt-2">Categories &nbsp;</span>
                              {vaptDimensionsContainer && vaptDimensionsContainer.map((mainDim) => (
                                <FormControlLabel
                                  key={mainDim.id}
                                  control={
                                    <Checkbox
                                      checked={formData.category.some(id => id === mainDim._id)}
                                      onChange={handleInputChange}
                                      name="category"
                                      value={mainDim._id}
                                    />
                                  }
                                  label={mainDim.label}
                                />
                              ))}
                            </FormGroup>
                          </FormControl>
                        </div>

                        <div className='mt-1'>
                          <div className='row'>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-0">
                              <FormLabel component="legend" className='text-primary'>
                                Web Applications
                              </FormLabel>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                              <Button sx={{ color: 'blue' }} onClick={handleAddField}>Add</Button>
                            </div>
                          </div>

                          {dynamicFields.map((field, index) => (
                            <div className='row' key={index}>
                              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 p-0">
                                <TextField
                                  variant="outlined"
                                  fullWidth
                                  size='small'
                                  name="Web Applications"
                                  label="Web Applications"
                                  value={dynamicFields[index]}
                                  onChange={(e) => handleDynamicFieldChange(index, e.target.value)}
                                />
                              </div>
                              <div className='col-lg-1 col-md-3 col-sm-6 col-xs-6'>
                                <IconButton onClick={() => handleRemoveField(index)}>
                                  <DeleteIcon sx={{ color: 'red' }} />
                                </IconButton>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className='mt-1'>
                          <div className='row'>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-0">
                              <FormLabel component="legend" className='text-primary' >
                                Network Locations
                              </FormLabel>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                              <Button sx={{ color: 'blue' }} onClick={handleAddFieldNetwork}>Add</Button>
                            </div>
                          </div>
                          {dynamicFieldsNetwork.map((field, index) => (
                            <div className='row'>
                              <div key={index} className="col-lg-4 col-md-6 col-sm-12 col-xs-12  p-0">
                                <TextField
                                  variant="outlined"
                                  fullWidth
                                  size='small'
                                  name="Network Locations"
                                  label="Network Locations"
                                  value={dynamicFieldsNetwork[index]}
                                  onChange={(e) => handleDynamicFieldChangeNetwork(index, e.target.value)}
                                />
                              </div>
                              <div className='col-lg-1 col-md-3 col-sm-6 col-xs-6'>
                                <IconButton onClick={() => handleRemoveFieldNetwork(index)}>
                                  <DeleteIcon sx={{ color: 'red' }} />
                                </IconButton>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="mt-1">
                          <FormControl component="fieldset">
                            <FormGroup row>
                              <span className="text-primary pt-2">Mobile Types &nbsp;</span>
                              <FormControlLabel
                                key='Android'
                                control={
                                  <Checkbox
                                    checked={formData.mobiletypes.includes('Android')}
                                    onChange={handleMobileTypesChange}
                                    name="Android"
                                    value="Android"
                                  />
                                }
                                label="Android"
                              />
                              <FormControlLabel
                                key='IOS'
                                control={
                                  <Checkbox
                                    checked={formData.mobiletypes.includes('IOS')}
                                    onChange={handleMobileTypesChange}
                                    name="IOS"
                                    value="IOS"
                                  />
                                }
                                label="IOS"
                              />
                            </FormGroup>
                          </FormControl>
                        </div>

                        <div className="mt-1">
                          <FormControl component="fieldset">
                            <FormGroup row>
                              <span className="text-primary pt-2">Cloud Services &nbsp;</span>
                              {cloudTypesContainer && cloudTypesContainer.map((type) => (
                                <FormControlLabel
                                  key={type.id}
                                  control={
                                    <Checkbox
                                      checked={formData.cloudtypes.includes(type.id)}
                                      onChange={handleInputChange}
                                      name="cloudtypes"
                                      value={type.id}
                                    />
                                  }
                                  label={type.label}
                                />
                              ))}
                            </FormGroup>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md ">
              </div>
            </div>
            <div className="center-card radio-card">
              <Button variant="contained" onClick={(e) => handleSubmit(e)}>Submit</Button>
            </div>
          </Card>
        </CardContent>
      </Card>
    </div>
  );
}
export default Editcompany;